declare global {
  interface Window {
    AndroidNativeBridge?: {
      domoReportBridge: (message: string) => void;
    };
    webkit?: {
      messageHandlers?: {
        domoReportBridge: {
          postMessage: (message: unknown) => void;
        };
      };
    };
  }
}

export const send = (event_name: string, data = {}) => {
  try {
    if (window.webkit?.messageHandlers) {
      window.webkit.messageHandlers.domoReportBridge.postMessage({
        event_name: event_name,
        data: data,
      });
    } else if (window.AndroidNativeBridge) {
      window.AndroidNativeBridge.domoReportBridge(
        JSON.stringify({
          event_name: event_name,
          data: data,
        })
      );
    }
  } catch (e) {
    console.error('No domoReportBridge defined ', e);
  }
};
